import { collection } from '@/infra/collection'
import { action, computed } from 'mobx'
import { Id } from '@/infra/id'
import { TaxPayer, type TaxPayerProps } from './TaxPayer'
import { Spouse, type SpouseProps } from './Spouse'
import { Dependent, type DependentProps } from './Dependent'

export interface BasicInformationProps {
  taxPayer: TaxPayerProps
  spouse: SpouseProps | null
  dependents: DependentProps[]
}

export class BasicInformation {
  readonly taxPayer = new TaxPayer()
  readonly spouse = new Spouse()

  readonly dependents = collection({
    getModelId: (m) => m.id,
    getDataId: (d) => d.id,
    create: () => new Dependent(),
  })

  @computed
  get activeDependents() {
    return this.dependents.items.filter((dependent) => !dependent.archived)
  }

  @computed
  get archivedDependents() {
    return this.dependents.items.filter((dependent) => dependent.archived)
  }

  @action.bound
  set(props: Partial<BasicInformationProps>): this {
    if (props.taxPayer) {
      this.taxPayer.set(props.taxPayer)
    }
    if (props.spouse) {
      this.spouse.set(props.spouse)
    }
    if (props.dependents) {
      this.dependents.reset(props.dependents)
    }
    return this
  }

  toProps(): BasicInformationProps {
    return {
      taxPayer: this.taxPayer.toProps(),
      spouse: this.spouse.id !== Id.none ? this.spouse.toProps() : null,
      dependents: this.dependents.items.map((d) => d.toProps()),
    }
  }
}
